export default __webpack_public_path__ + "static/media/Group 171.233d6480.svg";